// import { fuseReactLatestVersion } from './changelog/ChangelogDoc';
// import FuseComponentsNavigation from './fuse-components/FuseComponentsNavigation';

const EmployeeNavigation = {
  id: 'employeeInfo',
  title: 'Employee Info',
  icon: 'heroicons-outline:support',
  type: 'group',
  children: [
    {
      id: 'leave',
      title: 'Leave',
      type: 'item',
      icon: 'heroicons-outline:speakerphone',
    },
    {
      id: 'evaluation',
      title: 'Evaluation',
      type: 'item',
      icon: 'heroicons-outline:light-bulb',
    },
    {
      id: 'training',
      title: 'Training',
      type: 'item',
      icon: 'heroicons-outline:presentation-chart-line',
    },
    {
      id: 'okr',
      title: 'OKR',
      type: 'item',
      icon: 'heroicons-outline:cube-transparent',
    },
    {
      id: 'task',
      title: 'Task',
      type: 'item',
      icon: 'heroicons-outline:annotation',
    },
    
    // FuseComponentsNavigation,
  ],
};

export default EmployeeNavigation;
